'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _utilsImmutable = require('@bibliocommons/utils-immutable');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var BcReactComponent = function (_Component) {
  _inherits(BcReactComponent, _Component);

  function BcReactComponent() {
    _classCallCheck(this, BcReactComponent);

    return _possibleConstructorReturn(this, (BcReactComponent.__proto__ || Object.getPrototypeOf(BcReactComponent)).apply(this, arguments));
  }

  _createClass(BcReactComponent, [{
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !(0, _utilsImmutable.shallowEquals)(this.props, nextProps) || !(0, _utilsImmutable.shallowEquals)(this.state, nextState);
    }
  }, {
    key: 'bindAll',
    value: function bindAll() {
      var _this2 = this;

      for (var _len = arguments.length, methods = Array(_len), _key = 0; _key < _len; _key++) {
        methods[_key] = arguments[_key];
      }

      methods.forEach(function (method) {
        _this2[method] = _this2[method].bind(_this2);
      });
    }
  }]);

  return BcReactComponent;
}(_react.Component);

exports.default = BcReactComponent;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/base/bc-react-component/lib/components/BcReactComponent.component.js
// module id = 48
// module chunks = 0 1 2 3 4 5 6 7 8 9